/* eslint-disable consistent-return */
import { useCallback } from 'react';
import { useImmerReducer } from 'use-immer';
const getNextStep = (stepsList, answers, activeStep) => {
    var _a;
    const stepNodes = stepsList[activeStep];
    const hasMultipleNextSteps = stepNodes.length > 1;
    const currentAnswer = answers.find(answer => answer.step === activeStep);
    if (hasMultipleNextSteps) {
        return (_a = stepNodes.find(stepAnswer => { var _a; return ((_a = stepAnswer.answer) === null || _a === void 0 ? void 0 : _a.value) === (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.value); })) === null || _a === void 0 ? void 0 : _a.nextStep;
    }
    return stepNodes[0].nextStep;
};
export const stepsReducer = (state, action) => {
    switch (action.type) {
        case 'nextStep': {
            const { stepsList, activeStep, answers } = state;
            const nextStep = getNextStep(stepsList, answers, activeStep);
            if (!nextStep) {
                return;
            }
            state.previousSteps = [...state.previousSteps, activeStep];
            state.activeStep = nextStep;
            break;
        }
        case 'previousStep': {
            const { previousSteps } = state;
            state.previousSteps = previousSteps.slice(0, previousSteps.length - 1);
            state.activeStep = previousSteps[previousSteps.length - 1];
            break;
        }
        case 'updateAnswer': {
            const { activeStep, answers } = state;
            const { payload } = action;
            const currentAnswerIndex = answers.findIndex(answer => answer.step === activeStep);
            if (currentAnswerIndex >= 0) {
                const answersCopy = [...answers];
                answersCopy[currentAnswerIndex] = payload;
                state.answers = answersCopy.slice(0, currentAnswerIndex + 1);
            }
            else {
                state.answers = [...answers, payload];
            }
            break;
        }
        case 'throwError': {
            state.error = true;
            break;
        }
        case 'clearError': {
            state.error = false;
            break;
        }
        case 'confirmClose': {
            const { activeStep } = state;
            state.previousSteps = [...state.previousSteps, activeStep];
            state.activeStep = 'CloseConfirmation';
            break;
        }
        case 'closeFlow': {
            const { onCancelFlow } = state;
            onCancelFlow();
            break;
        }
        case 'updateStep': {
            const { activeStep } = state;
            state.previousSteps = [...state.previousSteps, activeStep];
            state.activeStep = action.payload;
            break;
        }
        case 'updateState': {
            return Object.assign(Object.assign({}, state), action.payload);
        }
        case 'updateRequest': {
            state.onRequest = action.payload;
            break;
        }
        case 'performRequest': {
            state.onRequest();
            break;
        }
        case 'updateRequestLoading': {
            state.isRequestLoading = action.payload;
            break;
        }
        case 'toggleFlow': {
            const { flow } = state;
            state.flow = flow === 'replacement' ? 'lost-stolen' : 'replacement';
            state.activeStep =
                flow === 'replacement' ? 'ReasonSelectionLostCard' : 'ReasonSelection';
            break;
        }
        default: {
            /* NOTE: https://gibbok.github.io/typescript-book/book/exhaustiveness-checking */
            const exhaustiveCheck = action;
            /* eslint-disable-next-line no-console */
            console.error(exhaustiveCheck);
        }
    }
};
const useStepsReducer = (initialState, middleware) => {
    const [state, dispatch] = useImmerReducer(stepsReducer, initialState);
    /*
     * NOTE: required to effectively memoize the values in the array returned by useStepsReducer
     * Read more: https://react.dev/reference/react/useMemo#memoizing-a-function
     */
    const dispatchWithMiddleware = useCallback((action) => {
        middleware(action);
        dispatch(action);
    }, [dispatch, middleware]);
    return [state, dispatchWithMiddleware];
};
export default useStepsReducer;
//# sourceMappingURL=useStepsReducer.js.map